<div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-6"   >
  <p-select
    placeholder="{{ 'shared.widgets.expression.select' | translate | titlecase }}"
    appendTo="body"
    [(ngModel)]="expression.FieldValueOperator"
    [options]="fieldOperatorItems"
    [style]="{ width: '100%', height: '36px' }"
    showClear
    (onChange)="operatorChanged($event)"
  ></p-select>
  <p-datepicker
    appendTo="body"
    [showIcon]="true"
    [(ngModel)]="selectedDate"
    [hidden]="expression.FieldValueOperator === fieldValueOperatorEnum.InPeriod"
  ></p-datepicker>
  <p-select
    placeholder="{{ 'shared.widgets.expression.select' | translate | titlecase }}"
    appendTo="body"
    [(ngModel)]="expression.Value"
    [hidden]="expression.FieldValueOperator !== fieldValueOperatorEnum.InPeriod"
    [options]="datePeriodItems"
    [style]="{ width: '100%', height: '36px' }"
    showClear
  ></p-select>
</div>
